export function normalizeRecoveryActions(value) {
  return Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [];
}

export function modelAccessRecoveryFromError(err) {
  const data = err?.response?.data || {};
  const rawActions = data.recovery_actions || data.recoveryActions;
  const recoveryActions = normalizeRecoveryActions(rawActions);
  const code = data.code || data.error || err?.code;
  const status = err?.response?.status;
  const isModelAccessError =
    status === 402 ||
    code === 'INSUFFICIENT_CREDITS' ||
    code === 'credits_exhausted' ||
    code === 'KEY_NOT_FOUND' ||
    code === 'NO_KEY_AVAILABLE';

  if (!isModelAccessError && recoveryActions.length === 0) return null;

  const canAddApiKey = recoveryActions.includes('add_api_key');
  const canBuyCredits = recoveryActions.includes('buy_credits');

  return {
    type: canAddApiKey ? 'credits_or_api_key' : 'credits',
    message: data.message || 'Add an API key for this model or buy credits to continue.',
    recoveryActions,
    canAddApiKey,
    canBuyCredits,
  };
}

export function modelAccessRecoveryMessage(err, fallback = 'Something went wrong') {
  const recovery = modelAccessRecoveryFromError(err);
  if (recovery) return recovery.message;
  return err?.response?.data?.error || err?.message || fallback;
}
